import { Link } from "react-router-dom";
import { latestUpdates } from "@/mocks/home";

export default function LatestUpdates() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">
              每日更新50+综艺，精彩内容不容错过
            </p>
          </div>
          <Link
            to="/category/remen"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors no-underline flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {latestUpdates.map((show) => (
            <Link
              key={show.id}
              to={`/article/${show.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="relative w-32 h-20 md:w-40 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={show.image}
                  alt={show.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  title={`${show.title} - 6789影视`}
                />
                <div className="absolute top-1.5 right-1.5 px-1.5 py-0.5 rounded text-[10px] bg-accent-500 text-white font-semibold">
                  {show.time}
                </div>
              </div>

              <div className="flex flex-col justify-between flex-1 min-w-0">
                <div>
                  <span className="text-[11px] text-primary-500 font-medium">
                    {show.category}
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-950 mt-1 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {show.title}
                  </h3>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {show.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}